"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ITrainerType = void 0;
var ITrainerType;
(function (ITrainerType) {
    ITrainerType["Motivational"] = "motivational";
    ITrainerType["Informativeandinstructional"] = "informativeandinstructional";
    ITrainerType["Calmandsteady"] = "calmandsteady";
    ITrainerType["Energeticandfun"] = "energeticandfun";
    ITrainerType["Focusedandintense"] = "focusedandintense";
    ITrainerType["Professionalolympicathlete"] = "professionalolympicathlete";
})(ITrainerType || (exports.ITrainerType = ITrainerType = {}));
//# sourceMappingURL=trainer-type.js.map